<template>
    <div class="bg-salesium-blue px-2 sm:px-8 py-2.5">
        <div class="container flex justify-between items-center mx-auto">
            <!-- Nav left -->
            <a href="/" class="flex items-center no-underline">
                <svg-vue
                    icon="salesium-logo-plain"
                    class="w-8 h-8 inline-block mr-3 fill-white"
                />
                <span
                    class="self-center text-2xl ml-2 text-white whitespace-nowrap hidden lg:block"
                    >Salesium</span
                >
            </a>
            <div v-if="user.type == 'customer'">
                <a
                    id="upgrade-to-pro"
                    title="Switch To Pro"
                    href="/pro-switch/"
                >
                    <svg-vue
                        icon="Go Pro Button"
                        class="w-25 h-8 mr-2 ml-5 fill-white"
                    />
                </a>
            </div>
            <div v-if="user.type == 'pro' && user.tier !== 'Premium'">
                <a
                    id="upgrade-to-premium"
                    title="Switch To Premium"
                    href="/premium-switch/"
                >
                    <svg-vue
                        icon="Go Premium Button"
                        class="w-25 h-8 mr-2 ml-5 fill-white"
                    />
                </a>
            </div>
            <!-- Nav center -->

            <!-- new nav search component code -->

            <div
                v-if="user"
                class="relative z-10 px-2 sm:flex items-center justify-center sm:inset-0 w-full lg:mr-20 mr-0 rounded-full"
                v-closable="{
                    handler: 'onClose',
                }"
            >
                <div class="w-full sm:w-3/5" v-if="displaySearchBox()">
                    <div class="grid grid-cols-2">
                    <form @submit.prevent="fetchPros">
                        <input
                            class="w-full rounded-lg"
                            type="text"
                            placeholder="Search for a Pro"
                            v-model="search_text"
                        />
                    </form>
                    <button
                        class="primary-btn rounded-lg px-4"
                        @click="advancedSearch">
                        Advanced
                    </button>
                    </div>
                    <div
                        class="absolute w-screen -left-1/4 lg:left-1/2 lg:-translate-x-1/2 lg:w-6/12 mt-2 max-h-96 overflow-y-scroll z-[60] border-1 shadow cursor-pointer"
                        v-if="showSearch"
                    >
                        <div
                            class="inline-block flex flex-col bg-white shadow rounded-lg overflow-hidden"
                        >
                            <table
                                v-if="!isLoading && returnPros.length"
                                class="min-w-full leading-normal bg-gray-200 z-50"
                            >
                                <thead>
                                    <tr>
                                        <th
                                            class="px-20 py-3 border-b-2 border-gray-200 bg-gray-200 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
                                        >
                                            Name/Job Title
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        class="hover:bg-gray-400 z-50"
                                        v-for="(pro, i) in returnPros"
                                        :key="i"
                                        @click="navigateToUser(pro.username)"
                                    >
                                        <td
                                            class="px-5 py-5 border-b border-gray-200 bg-white text-sm"
                                        >
                                            <div class="flex items-center">
                                                <div
                                                    class="flex-shrink-0 w-10 h-10"
                                                >
                                                    <img
                                                        v-show="
                                                            showingUserAvatar.includes(
                                                                pro.id
                                                            )
                                                        "
                                                        @load="
                                                            showingUserAvatar.push(
                                                                pro.id
                                                            )
                                                        "
                                                        :src="pro.avatar_uri"
                                                        alt="User Profile Picture"
                                                        class="w-10 h-10 rounded-full outline:nonedefault-avatar-icon"
                                                        :class="
                                                            user.type == 'pro'
                                                                ? user.care_score >
                                                                  3
                                                                    ? user.care_score >=
                                                                      4
                                                                        ? 'badgeBlue'
                                                                        : 'badgeGreen'
                                                                    : ''
                                                                : ''
                                                        "
                                                    />
                                                    <div
                                                        v-show="
                                                            !showingUserAvatar.includes(
                                                                pro.id
                                                            )
                                                        "
                                                        class="rounded-full bg-white"
                                                    >
                                                        <svg-vue
                                                            icon="circle-user"
                                                            title="default user avatar"
                                                            class="h-10"
                                                            :class="
                                                                user.type ==
                                                                'pro'
                                                                    ? user.care_score >
                                                                      3
                                                                        ? user.care_score >=
                                                                          4
                                                                            ? 'fill-salesium-blue'
                                                                            : 'fill-salesium-green'
                                                                        : ''
                                                                    : ''
                                                            "
                                                        />
                                                    </div>
                                                </div>
                                                <div class="ml-3">
                                                    <p
                                                        class="text-xs text-gray-900 whitespace-no-wrap"
                                                    >
                                                        {{pro.display_name}}
                                                    </p>
                                                </div>
                                                <div
                                                    class="px-10 py-5 text-sm"
                                                    v-if="pro.subindustry"
                                                >
                                                    <p
                                                        class="text-xs text-gray-900 whitespace-no-wrap"
                                                    >
                                                        {{ prettifySubindustry( pro.subindustry.tag) }}
                                                    </p>
                                                </div>
                                                <div  class="px-10 py-5 text-sm"
                                                      v-else>
                                                    <p class="text-xs text-gray-900 whitespace-no-wrap">
                                                        ---------------------
                                                    </p>
                                                </div>
                                                <div class="ml-3">
                                                    <p class="text-xs text-gray-900 whitespace-no-wrap">
                                                        {{pro.distance.toFixed(1)}} miles
                                                    </p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div
                                class="flex bg-white w-full my-20 justify-center items-center"
                                v-if="!isLoading && !returnPros.length"
                            >
                                No result found for this search.
                            </div>
                            <div
                                class="flex bg-white w-full my-20 justify-center items-center"
                                v-if="isLoading"
                            >
                                <div
                                    class="w-8 h-8 border-4 mx-5 my-5 border-blue-400 border-solid rounded-full animate-spin"
                                ></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Nav right -->
            <div v-if="user" class="flex flex-row">
                <!-- <button
          class="flex items-center pr-3 text-hint sm:hidden"
          aria-label="Show search"
          @click="() => (showSearch = !showSearch)"
        >
          <svg-vue
            icon="search"
            class="w-5 h-5 mr-2 fill-white"
            title="Show search"
          />
        </button> -->
                <!-- Start of changes to Icons -->
                <a
                    id="home-nav"
                    class="flex items-center pr-3 text-hint transition duration-150 ease-in-out focus:oultine-none outline-0 focus:outline-0 outline-transparent"
                    title="Home"
                    href="/"
                >
                    <svg-vue
                        icon="house"
                        title="Home"
                        class="w-6 h-6 mr-2 fill-white"
                    />
                </a>

                <a
                    id="storefront-nav"
                    v-if="user.type == 'pro'"
                    class="flex items-center pr-3 text-hint transition duration-150 ease-in-out focus:oultine-none outline-0 focus:outline-0 outline-transparent"
                    title="Storefront"
                    :href="'/storefront/' + user.username"
                >
                    <svg-vue
                        icon="store-sign"
                        title="storefront icon"
                        class="w-6 h-6 mr-2 fill-white"
                    />
                </a>

                <a
                    id="controlpanel-nav"
                    class="flex items-center pr-3 text-hint transition duration-150 ease-in-out focus:oultine-none outline-0 focus:outline-0 outline-transparent hidden lg:block"
                    title="controlpanel"
                    href="/control-panel"
                >
                    <svg-vue
                        icon="gear-solid"
                        title="control-panel icon"
                        class="w-6 h-6 mr-2 fill-white"
                    />
                </a>
                <a
                    id="logout-nav"
                    class="flex items-center pr-3 text-hint transition duration-150 ease-in-out focus:oultine-none outline-0 focus:outline-0 outline-transparent"
                    title="logout"
                    href="/logout"
                >
                    <svg-vue
                        icon="logout-icon"
                        title="storefront icon"
                        class="w-6 h-6 mr-2 fill-white"
                    />
                </a>
            </div>
            <div v-else class="flex flex-row">
                <a
                    id="login-nav"
                    class="flex items-center pr-3 text-hint transition duration-150 ease-in-out focus:oultine-none outline-0 focus:outline-0 outline-transparent"
                    title="login"
                    href="/login"
                >
                    <svg-vue
                        icon="avatar"
                        title="storefront icon"
                        class="w-6 h-6 mr-2 fill-white"
                    />
                </a>
            </div>
        </div>
        <!-- Mobile Search -->
        <!--     <div
      class="container flex-wrap items-center mx-auto justify-between sm:hidden mt-2.5"
      :class="{ hidden: !showSearch, flex: showSearch }"
    >
      <div class="w-4/5 sm:max-w-m">
        <form @submit.prevent="onSearch">
          <label
            for="search"
            class="sr-only"
          >Search</label>
          <div class="relative">
            <input
              id="search"
              name="search"
              class="
              block
              w-full
              bg-salesium-grey-100
              border border-transparent
              rounded-md
              py-2
              pr-3
              text-hint
              placeholder-gray-600
              focus:outline-none
              focus:bg-white
              focus:border-white
              focus:ring-white
              focus:text-gray-900
              focus:placeholder-gray-500
            "
              placeholder="Search for a Pro, or Job title"
              type="search"
              v-model="search"
            />
            <button
              title="Search"
              type="submit"
              class="
              absolute
              inset-y-0
              right-0
              pl-3
              flex
              items-center
            "
            >
              <svg-vue
                icon="search"
                title="Search"
                class="w-6 h-6 inline-block mr-3 fill-black"
              />
            </button>
          </div>
        </form>
      </div>
      <div
        class="w-1/5 sm:max-w-m justify-end"
        :class="{'hidden': !showSearch, 'flex': showSearch}"
      >
        <button
          class="items-center pr-3 text-hint sm:hidden"
          aria-label="Hide search"
          @click="() => showSearch = false"
        >
          <svg-vue
            icon="caret-up-solid"
            title="Hide search"
            class="w-6 h-6 mr-2 fill-white"
          />
        </button>
      </div>
    </div> -->
    </div>
</template>
<script>
import VueClosable from "vue-closable";

export default {
    mounted() {
      console.log( this.user);
//      console.log( this.user.tier);
    },
    data() {
        return {
            showSearch: false,
            returnPros: [],
            search_text: "",
            search_location: {},
            isLoading: false,
            showingUserAvatar: [],
            relevanceThreshold: 0.2,
            sortOrder: ['distance', 'relevance'],
        };
    },
    props: ["user", "location"],
    methods: {
        async onSearch() {
            // TODO: implement search
        },
        async fetchPros() {
            this.isLoading = true;
            await axios
                .post("/api/user/search", {
                    search_text: this.search_text,
                    relevance_threshold: this.relevanceThreshold,
                    search_location: (this.user.home_location && this.user.home_location.lat && this.user.home_location.lng) ? {
                        'lat': this.user.home_location.lat,
                        'lng': this.user.home_location.lng
                    } : ((this.user.business_location && this.user.business_location.lat && this.user.business_location.lng) ? {
                        'lat': this.user.business_location.lat,
                        'lng': this.user.business_location.lng
                    } : null),
                    sort_order: this.sortOrder,
                    postal_code: (this.user.home_location && this.user.home_location.postal_code) ? {
                        'postal_code' : this.user.home_location.postal_code}
                        : (this.user.business_location && this.user.business_location.postal_code) ? {
                        'postal_code' : this.user.business_location.postal_code}
                        : { 'postal_code' : 'none'},
                })
                .then((response) => {
                    this.isLoading = false;
                    this.showSearch = true;
                    this.returnPros = response.data;
//                    console.log( JSON.stringify( response.data));
                })
                .catch((error) => {
                    this.isLoading = false;
                    this.showSearch = true;
                    this.errorMessage = "Search failed!";
                    this.showError = true;
                });
        },
        advancedSearch(){
            let searchUrl = "/landing/?";
            let searchArgs = 0;
            if( this.search_text) {
                searchUrl += "search_text=" + this.search_text;
                searchUrl += "&search_now";
                searchArgs ++;
            }
            let postal_code = (this.user.home_location && this.user.home_location.postal_code)
                    ? { 'postal_code' : this.user.home_location.postal_code}
                    : (this.user.business_location && this.user.business_location.postal_code)
                        ? { 'postal_code' : this.user.business_location.postal_code}
                        : { 'postal_code' : null};
            if( searchArgs > 0) searchUrl += '&';
            if( postal_code["postal_code"] !== null)
                searchUrl += 'postal_code=' + postal_code["postal_code"];
            window.location.href = searchUrl;
        },
        prettifySubindustry( text) {
            return text.replaceAll( "_", " ").replace( "#", "");
        },
        navigateToUser(username) {
            window.location.href = "/storefront/" + username;
        },
        displaySearchBox() {
            return !( window.location.href.includes( "/search/") || window.location.href.includes( "/landing/"));
        },
        onClose() {
            this.showSearch = false;
        },
    },
};
</script>
